var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_sms-edit",
    "data-name": "vuesax/linear/sms-edit",
    transform: "translate(-748 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms-edit",
    transform: "translate(748 250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12,21H6c-3.6,0-6-1.853-6-6.176V6.176C0,1.853,2.4,0,6,0H18c3.6,0,6,1.853,6,6.176V9.882",
    transform: "translate(2 3.5)",
    fill: "none",
    stroke: "#1d1640",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M10,0,6.87,2.5a3.166,3.166,0,0,1-3.75,0L0,0",
    transform: "translate(9 10.724)",
    fill: "none",
    stroke: "#1d1640",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(19.171 18.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.039.573.5,4.113a1.232,1.232,0,0,0-.3.59l-.19,1.35a.635.635,0,0,0,.76.76l1.35-.19a1.189,1.189,0,0,0,.59-.3l3.54-3.54a1.365,1.365,0,0,0,0-2.22A1.361,1.361,0,0,0,4.039.573Z",
    fill: "none",
    stroke: "#1d1640",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0A3.185,3.185,0,0,0,2.22,2.22",
    transform: "translate(3.529 1.083)",
    fill: "none",
    stroke: "#1d1640",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplane);
export default __webpack_public_path__ + "static/media/complane.77da67e91fbef34f7f65f01c10b3fed9.svg";
export { ForwardRef as ReactComponent };